/* === Align Product Card Elements Across Rows === */
(function () {
  'use strict';

  var SLOTS = [
    '.tt-title',
    '.thumbnail_small_description',
    '.tt-price',
    '.productitem-option1-js',
    '.productitem-option2-js',
    '.pl-swatches-collection'
  ];

  var CONTAINERS = '.tt-layout-product-item, .tt-product-listing.row';

  function alignCards() {
    /* Remove leftover spacer elements from previous code versions */
    var spacers = document.querySelectorAll('[class*="spacer"]');
    for (var s = 0; s < spacers.length; s++) spacers[s].parentNode.removeChild(spacers[s]);

    var containers = document.querySelectorAll(CONTAINERS);

    for (var ci = 0; ci < containers.length; ci++) {
      var container = containers[ci];
      var cols = container.querySelectorAll(':scope > [class*="col-"]');
      if (cols.length < 2) continue;

      /* Group cards by visual row using offsetTop (works for offscreen elements too) */
      var cardMap = {};
      for (var i = 0; i < cols.length; i++) {
        var card = cols[i].querySelector('.tt-product.product-parent');
        if (!card) continue;
        var key = Math.round(cols[i].offsetTop);
        if (!cardMap[key]) cardMap[key] = [];
        cardMap[key].push(card);
      }

      var keys = Object.keys(cardMap);
      for (var ki = 0; ki < keys.length; ki++) {
        var rowCards = cardMap[keys[ki]];
        if (rowCards.length < 2) continue;

        /*
         * TWO-PASS: measure first, apply once.
         *
         * Pass 1 — measure natural height+margins of each element.
         * Pass 2 — for each element:
         *   exists + shorter → increase min-height
         *   missing → accumulate gap, apply as margin-top on next element
         */

        /* PASS 1 */
        var grid = [];
        for (var ri = 0; ri < rowCards.length; ri++) {
          var row = [];
          for (var si = 0; si < SLOTS.length; si++) {
            var el = rowCards[ri].querySelector(SLOTS[si]);
            if (el && getComputedStyle(el).display !== 'none' && el.offsetHeight > 0) {
              var cs = getComputedStyle(el);
              row.push({
                el: el,
                h: el.offsetHeight,
                totalH: el.offsetHeight + parseFloat(cs.marginTop || 0) + parseFloat(cs.marginBottom || 0),
                exists: true
              });
            } else {
              row.push({ el: null, h: 0, totalH: 0, exists: false });
            }
          }
          grid.push(row);
        }

        /* Max per slot */
        var maxPerSlot = [];
        for (var si2 = 0; si2 < SLOTS.length; si2++) {
          var m = 0;
          for (var ri2 = 0; ri2 < grid.length; ri2++) {
            if (grid[ri2][si2].totalH > m) m = grid[ri2][si2].totalH;
          }
          maxPerSlot.push(m);
        }

        /* PASS 2 */
        for (var ri3 = 0; ri3 < grid.length; ri3++) {
          var accGap = 0;
          for (var si3 = 0; si3 < SLOTS.length; si3++) {
            var sd = grid[ri3][si3];
            if (sd.exists) {
              if (accGap > 0) {
                sd.el.style.marginTop = accGap + 'px';
                accGap = 0;
              }
              if (sd.totalH < maxPerSlot[si3]) {
                var diff = maxPerSlot[si3] - sd.totalH;
                sd.el.style.minHeight = (sd.h + diff) + 'px';
              }
            } else {
              accGap += maxPerSlot[si3];
            }
          }
        }
      }
    }
  }

  function resetAndAlign() {
    var all = document.querySelectorAll(
      '.tt-description:not(.onerowactions) > *, .tt-option-block > *'
    );
    for (var i = 0; i < all.length; i++) {
      all[i].style.minHeight = '';
      all[i].style.marginTop = '';
    }
    alignCards();
  }

  /* Run after page loads */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(resetAndAlign, 500);
    });
  } else {
    setTimeout(resetAndAlign, 500);
  }

  /* Re-run on resize */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resetAndAlign, 300);
  });

  /* Re-run on swatch click */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tt-options-swatch')) {
      setTimeout(resetAndAlign, 100);
    }
  });

  /*
   * MutationObserver — detect new products loaded by infinite scroll.
   * Watches for new child nodes added to product containers.
   */
  var observer = new MutationObserver(function (mutations) {
    var hasNewCards = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (
            node.classList.contains('tt-col-item') ||
            node.querySelector && node.querySelector('.tt-product')
          )) {
            hasNewCards = true;
            break;
          }
        }
      }
      if (hasNewCards) break;
    }
    if (hasNewCards) {
      setTimeout(resetAndAlign, 500);
    }
  });

  /* Observe all product containers for new children */
  function startObserving() {
    var containers = document.querySelectorAll(CONTAINERS);
    for (var i = 0; i < containers.length; i++) {
      observer.observe(containers[i], { childList: true, subtree: true });
    }
    /* Also observe body for new containers (e.g., homepage sections loading) */
    observer.observe(document.body, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
